/**
 * Helper de vibración táctil para celulares del personal (vibración nativa).
 */
export function vibrarAvisoOrdenLista() {
  if (typeof window !== 'undefined' && 'vibrate' in navigator) {
    try {
      // Secuencia: vibra 200ms, pausa 100ms, vibra 200ms, pausa 100ms, vibra 400ms
      navigator.vibrate([200, 100, 200, 100, 400]);
    } catch {
      // Ignorar si el sistema operativo bloquea la vibración
    }
  }
}
